import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { loginApi } from '../api/authApi';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, rehydrate from localStorage
  useEffect(() => {
    const stored = localStorage.getItem('bhishi_user');
    const token  = localStorage.getItem('bhishi_token');
    if (stored && token) {
      const parsed = JSON.parse(stored);
      // Strict check — only SuperAdmin allowed
      if (parsed.role !== 'SuperAdmin') {
        logout('Access denied. This panel is for Super Admins only.');
      } else {
        setUser(parsed);
      }
    }
    setLoading(false);
  }, []); // eslint-disable-line

  const login = useCallback(async ({ phone, password }) => {
    const res = await loginApi({ phone, password });
    const { token, data } = res.data;
    const u = data ? data.user : res.data.user; // accommodate nested structure

    if (u.role !== 'SuperAdmin') {
      toast.error('Access denied. Super Admin credentials required.');
      throw new Error('Unauthorized role');
    }

    localStorage.setItem('bhishi_token', token);
    localStorage.setItem('bhishi_user', JSON.stringify(u));
    setUser(u);
    return u;
  }, []);

  const logout = useCallback((msg) => {
    localStorage.removeItem('bhishi_token');
    localStorage.removeItem('bhishi_user');
    setUser(null);
    if (msg) toast.error(msg);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export default AuthContext;
